export const SUPPORTED_SETTING_ID_MAP = {
  locationThresholdSettingModal: "locationThresholdSettingModal",
  editQueuePriorityModal: "editQueuePriorityModal"
};
